import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { ErrorText } from '../../../components';


export default class Details extends Component {
    state = {
        image: '',
        error: ''
    }


    onSave = () => {
        const { image } = this.state;
        let error = '';
        if ((image.size / 1024 / 1024) > 10) error = 'File should be less than 10 MB.';

        if (error) {
            this.setState({ error });
        } else {
            this.props.uploadImage(image, this.props.isSubCategory);
        }
    }

    onInputChange = e => {
        this.setState({
            image: e.target.files[0]
        })
    }

    render() {
        const { image, error } = this.state;
        const { show, onHide, data } = this.props;
        let imageURL = data.image;
        if (image) imageURL = URL.createObjectURL(image);

        return (
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Category Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <div className="form-group">
                                <label>Name</label>
                                <p>{data.displayName}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <input
                                    ref={ref => { this.fileSelector = ref }}
                                    name="file"
                                    type="file"
                                    className="hidden" 
                                    onChange={this.onInputChange}
                                />
                                <button className="btn btn-secondary" onClick={() => this.fileSelector.click()}>
                                    Upload Image
                                </button>
                                <ErrorText error={error}/>
                            </div>
                        </div>
                        <div className="col-md-12">
                            {imageURL ? (
                                <>
                                    <p>Image</p>
                                    <img src={imageURL} atl={data.displayName} width="300px"/> 
                                </>
                            ): null}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={onHide}>Close</button>
                    <button className="btn btn-primary" onClick={this.onSave} disabled={!image}>Save</button>
                </Modal.Footer>
            </Modal>
        )
    }
};